require('../modules/es7.array.includes');
require('../modules/es7.array.flat-map');
require('../modules/es7.array.flatten');
module.exports = require('../modules/_core').Array;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/es7/array.js
// module id = ./node_modules/core-js/es7/array.js
// module chunks = polyfills